/**
 * @flow
 * @relayHash c2bdfdab07e5e70b9b10c7c6ad797f6e
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type ToggleReviewAssetReactionInput = {|
  reactionId: string,
  reviewAssetId: string,
  clientMutationId?: ?string,
|};
export type ToggleReviewAssetReactionMutationVariables = {|
  input: ToggleReviewAssetReactionInput
|};
export type ToggleReviewAssetReactionMutationResponse = {|
  +toggleReviewAssetReaction: ?{|
    +reviewAsset: ?{|
      +id: string,
      +reactions: ?$ReadOnlyArray<?{|
        +id: ?string,
        +definitionId: ?string,
        +name: ?string,
        +color: ?string,
        +number: ?number,
        +users: ?$ReadOnlyArray<?{|
          +id: string,
          +fullName: ?string,
          +representativeImageUrl: ?string,
        |}>,
      |}>,
    |}
  |}
|};
export type ToggleReviewAssetReactionMutation = {|
  variables: ToggleReviewAssetReactionMutationVariables,
  response: ToggleReviewAssetReactionMutationResponse,
|};
*/


/*
mutation ToggleReviewAssetReactionMutation(
  $input: ToggleReviewAssetReactionInput!
) {
  toggleReviewAssetReaction(input: $input) {
    reviewAsset {
      id
      reactions {
        id
        definitionId
        name
        color
        number
        users {
          id
          fullName
          representativeImageUrl
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "ToggleReviewAssetReactionInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "toggleReviewAssetReaction",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ToggleReviewAssetReactionPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "reviewAsset",
        "storageKey": null,
        "args": null,
        "concreteType": "ReviewAssetNode",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "reactions",
            "storageKey": null,
            "args": null,
            "concreteType": "ReactionNode",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "definitionId",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "color",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "number",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "users",
                "storageKey": null,
                "args": null,
                "concreteType": "UserNode",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "fullName",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "representativeImageUrl",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "ToggleReviewAssetReactionMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "ToggleReviewAssetReactionMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v2/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "ToggleReviewAssetReactionMutation",
    "id": null,
    "text": "mutation ToggleReviewAssetReactionMutation(\n  $input: ToggleReviewAssetReactionInput!\n) {\n  toggleReviewAssetReaction(input: $input) {\n    reviewAsset {\n      id\n      reactions {\n        id\n        definitionId\n        name\n        color\n        number\n        users {\n          id\n          fullName\n          representativeImageUrl\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '7cdd81c5a6948383ec208981e187c5e1';
module.exports = node;
